
import { defineComponent } from 'vue';
import ConfirmationOverlay from '@/components/ConfirmationOverlay.vue';
import ConfirmationDamageList from '@/components/ConfirmationDamageList.vue';
import { MutationTypes } from '@/store/mutationTypes';
import { ActionTypes } from '@/store/actionTypes';
import ConfirmationEventPayload from '@/types/ConfirmationEventPayload';
import TrailerAssessment from '@/types/TrailerAssessment';
import LastTrailerAssessmentResult from '@/types/LastTrailerAssessmentResult';
import queries from '@/queries';
import {
    TrailerAssessmentAnswer,
    TrailerAssessmentQuestion,
} from '@/types/TrailerAssessmentQuestion';

export default defineComponent({
    components: {
        ConfirmationOverlay,
        ConfirmationDamageList,
    },
    data(): {
        acceptedFirstStage: boolean;
        popupStage: number;
        isLoading: boolean;
    } {
        return {
            acceptedFirstStage: true,
            popupStage: 1,
            isLoading: false,
        };
    },
    props: {
        trailerAssessmentResult: {
            type: LastTrailerAssessmentResult || null,
            required: false,
        },
    },
    computed: {
        trailerAssessment(): TrailerAssessment {
            if (
                this.trailerAssessmentResult?.trailerAssessment instanceof
                TrailerAssessment
            )
                return this.trailerAssessmentResult.trailerAssessment;

            return new TrailerAssessment();
        },
        confirmationShown(): boolean {
            return this.$route.query.confirmation === 'confirmpretripgdamage';
        },
        acceptText(): string {
            return this.isLoading
                ? 'Proceeding'
                : 'Proceed to Trailer Assessment';
        },
    },
    methods: {
        async onAccept(): Promise<void> {
            if (this.acceptedFirstStage) {
                this.isLoading = true;
                await this.clearExistingTrailerDamage();
            }
            this.isLoading = false;
            this.$store.dispatch(ActionTypes.CLEAR_QUERY_PARAM_AND_ROUTE, {
                routeToName: 'TrailerAssessment',
                omitParam: 'confirmation',
            });
        },
        onReject(): void {
            this.popupStage = 1;
        },
        async clearExistingTrailerDamage(): Promise<void> {
            if (this.trailerAssessmentResult?.id !== undefined) {
                await queries.postDeactivateTrailerAssessment(
                    this.trailerAssessmentResult.id
                );
                this.$store.commit(
                    MutationTypes.SET_LAST_ACTIVE_TRAILER_ASSESSMENT_RESULT,
                    null
                );
            }
        },
        changeStage(confirmation: ConfirmationEventPayload): void {
            this.$store.dispatch(
                ActionTypes.UPDATE_TRAILER_ASSESSMENT_QUESTION,
                {
                    question:
                        TrailerAssessmentQuestion.PREVIOUS_DEFECTS_PERSIST,
                    answer: confirmation.didAccept
                        ? TrailerAssessmentAnswer.NO
                        : TrailerAssessmentAnswer.YES,
                }
            );

            this.popupStage = 2;
            this.acceptedFirstStage = confirmation.didAccept;
        },
    },
});
